import { render, staticRenderFns } from "./PropecInformationList.vue?vue&type=template&id=543731fe"
import script from "./PropecInformationList.vue?vue&type=script&lang=js"
export * from "./PropecInformationList.vue?vue&type=script&lang=js"
import style0 from "./PropecInformationList.vue?vue&type=style&index=0&id=543731fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports